<template>
    <v-container fluid fill-height>
        <v-row>
            <v-col cols="12" md="6">
                <v-card elevation="0" outline>
                    <v-card-title primary-title>
                        <v-row>
                            <v-col cols="12" align="start">
                                <div
                                    v-if="$vuetify.breakpoint.mdAndDown"
                                    class="
                                        primary--text
                                        text-overline text-center
                                    "
                                >
                                    Detalles del perfil
                                </div>
                                <div
                                    v-else
                                    class="
                                        font-weight-light
                                        primary--text
                                        text-h5 text-capitalize
                                        mt-n1
                                    "
                                >
                                    <v-icon large>
                                        mdi-smart-card-outline
                                    </v-icon>
                                    Detalles del perfil
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title
                                    class="text-h5 mb-1 text-center"
                                >
                                    <v-avatar size="60" color="primary">
                                        <span class="white--text text-h5">{{
                                            nameEncode
                                        }}</span>
                                    </v-avatar>
                                    <div class="my-2 text-overline text-sm-h6">
                                        {{ fullName }}
                                    </div>
                                </v-list-item-title>
                                <!-- <v-divider class="test"></v-divider> -->
                                <v-list-item-subtitle class="ma-4">
                                    <div
                                        v-if="cuenta.nombre"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">Nombre</p>
                                        <p>{{ cuenta.nombre }}</p>
                                    </div>
                                    <div
                                        v-if="cuenta.apellidos"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">
                                            Apellidos
                                        </p>
                                        <p>{{ cuenta.apellidos }}</p>
                                    </div>
                                    <div
                                        v-if="cuenta.tipo_documento"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">
                                            {{ cuenta.tipo_documento }}
                                        </p>
                                        <p>{{ cuenta.documento }}</p>
                                    </div>
                                    <div
                                        v-if="cuenta.email"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">Email</p>
                                        <p>{{ cuenta.email }}</p>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                        <p class="font-weight-medium">Rol</p>
                                        <p>{{ rol }}</p>
                                    </div>
                                    <div
                                        v-if="cuenta.numeros_contacto"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">
                                            Contacto
                                        </p>
                                        <p>
                                            {{
                                                cuenta.numeros_contacto
                                                    .toString()
                                                    .replace(',', ', ')
                                            }}
                                        </p>
                                    </div>
                                    <div
                                        v-if="cuenta.direccion"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">
                                            Dirección
                                        </p>
                                        <p>
                                            {{ cuenta.direccion }}
                                        </p>
                                    </div>
                                    <div
                                        v-if="cuenta.NUSS"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">NUSS</p>
                                        <p>
                                            {{ cuenta.NUSS }}
                                        </p>
                                    </div>
                                    <div
                                        v-if="cuenta.IBAN"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">IBAN</p>
                                        <p>
                                            {{ cuenta.IBAN }}
                                        </p>
                                    </div>
                                    <div
                                        v-if="cuenta.talla"
                                        class="d-flex justify-space-between"
                                    >
                                        <p class="font-weight-medium">Talla</p>
                                        <p>
                                            {{ cuenta.talla }}
                                        </p>
                                    </div>
                                </v-list-item-subtitle>
                                <!-- <v-divider class="test"></v-divider> -->
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-text>

                    <!-- <v-divider class="test"></v-divider> -->
                    <v-card-actions
                        class="d-flex justify-end"
                        :class="
                            cuenta.estado == 'ALTA'
                                ? 'my-color-s'
                                : 'my-color-d'
                        "
                    >
                        <p class="ma-0 me-2 overline white--text text-left">
                            {{ cuenta.estado }}
                        </p>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <CommercialCommunicate :elevationProp="12" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import CommercialCommunicate from '@/components/CommercialCommunicate/CommercialCommunicate.vue';

export default {
    name: 'MiZona',
    data: () => ({}),
    methods: {},
    components: {
        CommercialCommunicate,
    },
    computed: {
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        rol() {
            return this.$store.state.general.rolesDecode[this.rolEncoded];
        },
        nameEncode() {
            let nameEncoded =
                this.rol == 'SuperAdmin'
                    ? this.fullName.split('_')
                    : this.fullName.split(' ');

            if (nameEncoded.length >= 2) {
                return `${nameEncoded[0][0].toUpperCase()}${nameEncoded[1][0].toUpperCase()}`;
            } else {
                return `UNDF`;
            }
        },
        drawer: {
            get() {
                return this.$store.state.general.IsOpenSideBar;
            },
            set(val) {
                if (!val) this.$store.dispatch('general/closeSideBar');
            },
        },

        ...mapState('login', {
            fullName: (state) => state.nombre,
            rolEncoded: (state) => state.rol,
            // cuenta: (state) => state.cuenta,
        }),
    },
};
</script>

<style>
.my-color-s {
    background-color: #05b805;
    width: 100%;
    height: 100%;
}
.my-color-d {
    background-color: #e41620;
    width: 100%;
    height: 100%;
}
</style>
